import React, {Component} from 'react';
import Main from '../../components/smart/Main';
import FloatContainer from '../../components/dummy/FloatContainer';
import CommitmentIcon from './../../Icons/CommitmentIcon.png';
import ProductsIcon from './../../Icons/ProductsIcon.png';
import ServiceIcon from './../../Icons/ServiceIcon.png';
import Login from '../../components/dummy/Login';

class EmployerPage extends Component {
    render() {
        return (
                
                <Main Title="Already a Client?">
                    <ul style={{listStyleType: "none"}}>
                        <li>Log in to access reports</li>
                        <li>View plan information</li>
                        <li>And other client resources</li>
                    </ul>
                    <Login Page="Employer" URL="https://www.cachepremier.com/group/group_login"  ID="UserName" Key="Password" ID_Key="login_id" Key_Key="password" ></Login>
                    <hr></hr>
                    <h3 className="Main_Title">Why Choose Matrix Healthcare?</h3>
                    <p className="Main_Description" style={{width:"60%", margin:"auto", paddingBottom:"10px"}}>When you work with Matrix Healthcare, you will be working with qualified and experienced professionals who will help you through the technical and complicated process of administering insurance for your employees. 
                Our employees are dedicated to helping you get the most out of your coverage, and to give you the peace of mind that comes from knowing you and your employees are protected. 
                Along with superior coverage, we provide each of our clients with dedicated customer service and we're easily and quickly accessible to answer questions or assist with any issues that arise.</p>
                    <FloatContainer>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={CommitmentIcon}alt="Commitment Icon"></img>
                                <h4>Commitment</h4>
                            </div>
                            <p>At Matrix Healthcare, our most significant commitment is to providing a seamless benefits experience for you, both employer and employees. 
                                <br></br>We are dedicated to providing the best coverage at a competitive price for our members by utilizing our years of experience in the industry. 
                                <br></br>Your partnership with Matrix Healthcare not only demonstrates your commitment to your employees, but also reveals your commitment to their families and loved ones.  
                                <br></br><br></br>For more information, please reach out to your broker or one of our partnered brokers.
                            </p>
                        </div>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={ProductsIcon} alt="Products Icon"></img>
                                <h4>Products</h4>
                            </div>  
                            <p>Matrix Healthcare started with a vision to help provide affordable and quality dental care to our local business partners.
                                With over 2,700 dentists in-network, it’s easier than ever to provide care for your employees and their families.
                                <br></br><br></br>Our vision product was built to simplify our members' experience and our reimbursement program makes it easy for your employees to see any provider, creating a stress-free experience for your employees who utilize their vision coverage.
                            </p>
                        </div>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={ServiceIcon} alt="Service Icon"></img>
                                <h4>Service</h4>
                            </div>
                            <p>Here at Matrix Healthcare, our unrivaled customer service sets us apart from the competition.
                                <br></br>We have dedicated Account Managers who understand the complexities of dental and vision products and can be reached directly with any questions regarding plan design, claim resolution, data collection and reporting. 
                            </p>
                                <br></br><h5>Matrix Healthcare: Making Dental Personal. </h5>
                        </div>
                    </FloatContainer>
                </Main>
        )
    }
};

export default EmployerPage;

